/*
 * @Description  :
 * @Version      : 1.0.0
 * @Author       : Luoye
 * @Date         : 2022-08-03 15:25:49
 * @LastEditors  : Luoye
 * @FilePath     : /namibox_client_web/src/views/app-guide.ReactPage/index.tsx
 * Copyright (C) 2022 rose. All rights reserved.
 */
import React from 'react';
import { render } from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import reudcer from './store/reducer';
import App from './App';
import 'SRC/static/styles/reset.scss';

const store = createStore(reudcer);

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);
